export * from './overlay.directive';
export * from './overlay.service';
export * from './overlay.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/overlay/shared/index.ts